import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Music, Radio, Waves, Search, Lightbulb, Palette, FlaskConical, Rocket } from "lucide-react";
import { useContent } from "../../context/ContentContext";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import WhatsAppButton from "../../components/WhatsAppButton";
import VideoGallery from "../../components/VideoGallery";
import AudioReelPlayer from "../../components/AudioReelPlayer";

// Assets
const AUDIO_REEL_MP3 = "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/y4dryatz_Brand%20Shower%202025.mp3";
const HERO_VIMEO_ID = "1145485724";

// Reference asset URLs uploaded by the client
const IMG = {
  DOWNY: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/ri7il2hx_DOWNY.png",
  CARACOL: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/gujuu2bi_CARACOL%20TE%20VE.png",
  FAB: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/nlgeln80_FAB%20ULTRA%20FLASH.png",
  NOTICIAS: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/ybed9kgm_NOTICIAS%20TELEMEDELLI%CC%81N.png",
  MOBIL: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/4yb9jp5c_MOBIL.png",
  AZULITO: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/bfvd8bml_EL%20AZULITO.png",
  CHOCO: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/c89xxeeu_CHOCO%20CONO%20MITI%20MITI.png",
  LABRU: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/u3kqhtaj_LA%20BRU.png",
  DAFITI: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/blu4l5hq_DAFITI%20CHILE.png",
  SINALERGYN: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/xrlfmoil_SIN-ALERGYN%20AFTER%20PIC.png",
  PASSINGPAPER: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/0k5qr1ue_PASSINGPAPER.png",
  AVIANCA: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/v8gx8oxo_AVIANCA%20LIFEMILES.png",
  IBUMIDOL: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/j4fovwwz_IBUMIDOL.png",
  ALKOSTO: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/0su1i9eh_ALKOSTO%20HERO.png",
  GENFAR: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/n2wm6d5h_GENFAR.png",
  JUANVALDEZ: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/0v2rrmkm_JUAN%20VALDEZ%20MUJERES%20CAFETERAS.png",
  PEPSI: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/q0fagh8g_PEPSI%20HAKA%201.png",
  MCPOLLO: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/nv1qfyge_MCPOLLO%20SUPERMERCADO.png",
  BOCATO: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/sa9pidk9_BOCATO.png",
  PEPSI_MADAME: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/mnrxecti_PEPSI%20FT.%20MADAME%20PERIN%C3%89%20%23VIVEHOY.png",
  FRUTTI: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/q6cwv3vy_FRUTTI.png",
  ARRURRU: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/hljxvg0h_ARRURRU-SHAMPOO.png",
  COLORLOTO: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/uujdnfc7_COLORLOTO%20REF.%20FRESCO.png",
  TABCIN: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/3ul3lfi1_TABCIN%20ACTIVE.png",
  AQUA24: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/dao4qdfi_AQUA%2024.png",
  GENFAR_DAR: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/5ap9z7ag_GENFAR-DAR.png",
  MCPOLLO_ASADO: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/ii0ngulu_MCPOLLO%20-%20ASADO.png",
  SEVENUP: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/mruasnn7_7UP.png",
};

const GALLERY_GROUPS = [
  {
    category: "ADAPTACIÓN",
    items: [
      { brand: "DOWNY", activo: "Brand emotional connection", image: IMG.DOWNY, video: "https://vimeo.com/1152688559" },
    ],
  },
  {
    category: "IDENTIDAD SONORA",
    items: [
      { brand: "CARACOL TE VE", activo: "Brand recall", image: IMG.CARACOL, video: "https://vimeo.com/1152694893" },
      { brand: "FAB ULTRA FLASH", activo: "Brand distinctiveness", image: IMG.FAB, video: "https://vimeo.com/1152690332" },
      { brand: "NOTICIAS TELEMEDELLÍN", activo: "Brand equity", image: IMG.NOTICIAS, video: "https://vimeo.com/1152692972" },
    ],
  },
  {
    category: "IDENTIDAD SONORA Y AUDIO INMERSIVO",
    items: [
      { brand: "MOBIL", activo: "Brand equity", image: IMG.MOBIL, video: "https://vimeo.com/1152692514" },
    ],
  },
  {
    category: "MÚSICA ORIGINAL",
    items: [
      { brand: "EL AZULITO", activo: "Brand emotional connection", image: IMG.AZULITO, video: "https://vimeo.com/564185234" },
      { brand: "CHOCO CONO MITI MITI", activo: "Brand equity", image: IMG.CHOCO, video: "https://vimeo.com/1152686335" },
      { brand: "LA BRU", activo: "Brand emotional connection", image: IMG.LABRU, video: "https://vimeo.com/1156053761" },
      { brand: "DAFITI CHILE", activo: "Brand distinctiveness", image: IMG.DAFITI, video: "https://vimeo.com/96944028" },
      { brand: "SIN-ALERGYN AFTER PIC", activo: "Brand distinctiveness", image: IMG.SINALERGYN, video: "https://vimeo.com/178525837" },
      { brand: "PASSINGPAPER", activo: "Brand emotional connection", image: IMG.PASSINGPAPER, video: "https://vimeo.com/11285090" },
      { brand: "AVIANCA LIFEMILES", activo: "Brand equity", image: IMG.AVIANCA, video: "https://vimeo.com/83863280" },
      { brand: "IBUMIDOL", activo: "Brand distinctiveness", image: IMG.IBUMIDOL, video: "https://vimeo.com/83863283" },
    ],
  },
  { category: "MÚSICA ORIGINAL Y AUDIO POST", items: [
    { brand: "ALKOSTO HERO", activo: "Brand equity", image: IMG.ALKOSTO, video: "https://vimeo.com/1152686882" },
    { brand: "GENFAR", activo: "Brand emotional connection", image: IMG.GENFAR, video: "https://vimeo.com/157335336" },
    { brand: "JUAN VALDEZ MUJERES CAFETERAS", activo: "Brand emotional connection", image: IMG.JUANVALDEZ, video: "https://vimeo.com/1152696264" },
    { brand: "PEPSI HAKA 1", activo: "Brand emotional connection", image: IMG.PEPSI, video: "https://vimeo.com/83863284" },
    { brand: "MCPOLLO SUPERMERCADO", activo: "Brand distinctiveness", image: IMG.MCPOLLO, video: "https://vimeo.com/188861664" },
    { brand: "BOCATO", activo: "Brand distinctiveness", image: IMG.BOCATO, video: "https://vimeo.com/188861246" },
    { brand: "PEPSI FT. MADAME PERINÉ #VIVEHOY", activo: "Brand emotional connection", image: IMG.PEPSI_MADAME, video: "https://vimeo.com/172760195" },
    { brand: "FRUTTI", activo: "Brand distinctiveness", image: IMG.FRUTTI, video: "https://vimeo.com/148575137" },
    { brand: "ARRURRU-SHAMPOO", activo: "Brand emotional connection", image: IMG.ARRURRU, video: "https://vimeo.com/112824864" },
    { brand: "COLORLOTO REF. FRESCO", activo: "Brand awareness", image: IMG.COLORLOTO, video: "https://vimeo.com/1005926294" },
    { brand: "TABCIN ACTIVE", activo: "Brand distinctiveness", image: IMG.TABCIN, video: "https://vimeo.com/82136057" },
    { brand: "AQUA 24", activo: "Brand emotional connection", image: IMG.AQUA24, video: "https://vimeo.com/188734789" },
    { brand: "GENFAR-DAR", activo: "Brand emotional connection", image: IMG.GENFAR_DAR, video: "https://vimeo.com/105805184" },
    { brand: "MCPOLLO - ASADO", activo: "Brand distinctiveness", image: IMG.MCPOLLO_ASADO, video: "https://vimeo.com/188861584" },
    { brand: "7UP", activo: "Brand distinctiveness", image: IMG.SEVENUP, video: "https://vimeo.com/112815122" },
  ] },
];

const COLUMNS = [
  {
    Icon: Music,
    title: "Música",
    text: "Creamos música a la medida de cada marca. Contamos con un amplio banco de música lista para licenciar y utilizamos herramientas de IA para definir rápidamente el camino sonoro de cada proyecto.",
  },
  {
    Icon: Radio,
    title: "Audio post",
    text: "Diseñamos y producimos la banda de sonido de cada marca. Un paisaje sonoro, un ringtone o el sonido para activaciones de marca y publicidad OOH son parte esencial de nuestro portafolio de audio branding.",
  },
  {
    Icon: Waves,
    title: "Audio Inmersivo",
    text: "Creamos experiencias de audio inmersivo en Dolby Atmos para lograr experiencias impactantes en streaming, eventos y diferentes puntos de contacto con la audiencia de marca.",
  },
];

// Secciones migradas desde MusicPage
const ADN_STEPS = [
  { n: "01", Icon: Search, title: "Descubrimiento", desc: "Escuchamos tu marca, tu categoría y tu audiencia. Identificamos el territorio sonoro correcto." },
  { n: "02", Icon: Lightbulb, title: "Estrategia sonora", desc: "Definimos personalidad, tono, referencias y el mapa emocional que guiará todo el sistema." },
  { n: "03", Icon: Palette, title: "Diseño de identidad", desc: "Componemos el ADN: melodía, ritmo, instrumentación, voces y arquetipo sonoro propios." },
  { n: "04", Icon: FlaskConical, title: "Sistema y variantes", desc: "Adaptamos el ADN a formatos, canales y momentos. Un solo sonido, infinitas expresiones." },
  { n: "05", Icon: Rocket, title: "Activación y guardianía", desc: "Implementamos, entrenamos equipos y cuidamos la coherencia sonora a lo largo del tiempo." },
];

export default function AudioBrandingPage() {
  const { content, loading } = useContent();

  if (loading || !content) {
    return <div className="min-h-screen bg-black flex items-center justify-center text-white/60 font-mono-caps tracking-widest">CARGANDO...</div>;
  }

  return (
    <div className="relative min-h-screen bg-black text-white overflow-x-hidden">
      <Header />

      {/* HERO with embedded Vimeo (autoplay) */}
      <section className="relative min-h-[92vh] flex items-center pt-28 pb-16 md:pt-32 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-[#ff6a2b]/15 to-black" />
        <div className="absolute inset-0 noise-overlay pointer-events-none" />

        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center">
          <div className="lg:col-span-6 xl:col-span-6 min-w-0">
            <p className="font-mono-caps text-xs md:text-sm tracking-[0.3em] uppercase text-[#ff8a3c]">Kilombo Music</p>
            <h1 className="mt-6 font-display font-black text-[40px] leading-[1.05] sm:text-5xl md:text-6xl lg:text-[64px] xl:text-7xl xl:leading-[1.02] pb-1">
              <span className="text-gradient-music">Audio</span>
              <br />
              Branding
            </h1>
            <p className="mt-6 max-w-xl text-white/90 text-base md:text-lg leading-snug font-medium">
              Guardianes de la identidad sonora de tu marca. Convertimos el sonido en un activo que se reconoce, se recuerda y se siente.
            </p>
            <div className="mt-8 md:mt-10 flex flex-wrap items-center gap-3">
              <Link to="/contact" className="btn-shine inline-flex items-center gap-3 rounded-full bg-[#ff6a2b] hover:bg-[#ff8a3c] text-black pl-6 pr-5 py-3.5 font-mono-caps text-xs tracking-[0.2em] uppercase transition-colors">
                Quiero empezar a sonar
                <span className="w-7 h-7 rounded-full bg-black text-white flex items-center justify-center"><ArrowRight className="w-3.5 h-3.5" /></span>
              </Link>
            </div>
          </div>

          {/* Embedded Vimeo video (autoplay muted loop) */}
          <div className="lg:col-span-6 xl:col-span-6 min-w-0">
            <div className="relative w-full aspect-video rounded-2xl overflow-hidden border border-white/15 shadow-2xl bg-black">
              <iframe
                src={`https://player.vimeo.com/video/${HERO_VIMEO_ID}?autoplay=1&muted=1&loop=1&background=0&byline=0&title=0&portrait=0&controls=1`}
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Kilombo Audio Branding"
              />
            </div>
            <p className="mt-3 font-mono-caps text-[10px] md:text-xs tracking-[0.3em] uppercase text-white/50 text-center lg:text-left">
              Reel · Audio Branding
            </p>
          </div>
        </div>
      </section>

      {/* AUDIO REEL section (below hero) */}
      <section className="relative bg-black py-10 md:py-14 px-6 border-t border-white/5">
        <div className="max-w-5xl mx-auto">
          <p className="font-mono-caps text-xs tracking-[0.3em] uppercase text-white/40 mb-4 text-center">— Reel de marcas —</p>
          <h2 className="font-display font-black text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-[1.05] text-white text-center mb-8 md:mb-10">
            Marcas que ya <span className="text-gradient-music">suenan</span> en tu memoria.
          </h2>
          <AudioReelPlayer src={AUDIO_REEL_MP3} label="Escucha aquí nuestro reel de audio logos" />
        </div>
      </section>

      {/* SECCIÓN — ¿Cuál es la necesidad de tu marca? (con 6 activos) */}
      <section className="relative py-20 md:py-32 px-6 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-black via-[#150806] to-black" />
        <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(60% 50% at 20% 30%, rgba(255,120,40,0.18) 0%, transparent 70%), radial-gradient(50% 40% at 85% 70%, rgba(46,201,168,0.10) 0%, transparent 70%)" }} />
        <div className="relative z-10 max-w-7xl mx-auto">
          <p className="font-mono-caps text-xs tracking-[0.3em] uppercase text-white/40 mb-6 text-center">— La pregunta —</p>
          <h2 className="font-display font-black text-4xl sm:text-5xl md:text-5xl lg:text-6xl leading-[1.05] text-white text-center">
            ¿Cuál es la <span className="text-gradient-music">necesidad</span>
            <br className="hidden md:block" />{" "}
            de tu marca?
          </h2>

          <div className="mt-14 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0 border-t border-l border-white/10">
            {[
              { n: "01", title: "Brand awareness", tag: "Reconocimiento", desc: "Que la identifiquen en segundos, incluso sin verla.", color: "#ff6a2b" },
              { n: "02", title: "Brand recall", tag: "Memorabilidad", desc: "Que aparezca sola en la memoria al pensar en la categoría.", color: "#2ec9a8" },
              { n: "03", title: "Brand consistency", tag: "Consistencia", desc: "Que todos los puntos de contacto digan lo mismo.", color: "#d4b23c" },
              { n: "04", title: "Brand emotional connection", tag: "Conexión", desc: "Que no solo la reconozcan: que sientan algo por ella.", color: "#8b7bff" },
              { n: "05", title: "Brand distinctiveness", tag: "Diferenciación", desc: "Cuando todas las marcas se ven parecidas, el sonido se vuelve ventaja competitiva.", color: "#4dc0ff" },
              { n: "06", title: "Brand equity", tag: "Capital de marca", desc: "Que el sonido se vuelva un activo que aumenta el valor de la marca.", color: "#ff8a3c", highlight: true },
            ].map((a) => (
              <div
                key={a.n}
                className={`relative p-6 md:p-8 border-r border-b border-white/10 hover:bg-black/60 transition-colors ${
                  a.highlight ? "bg-gradient-to-br from-[#ff6a2b]/15 to-transparent" : ""
                }`}
              >
                <span
                  className="absolute left-0 top-6 bottom-6 w-[3px] rounded-r-full"
                  style={{ background: a.color }}
                />
                <div className="pl-3">
                  <p className="font-mono-caps text-sm tracking-[0.15em]" style={{ color: a.color }}>{a.n}</p>
                  <h3 className="mt-3 font-display font-bold text-lg md:text-xl lg:text-2xl leading-snug pt-1" style={{ color: a.color }}>
                    {a.title} <span className="text-white/60 font-normal">— {a.tag}</span>
                  </h3>
                  <p className="mt-3 text-white/70 text-sm md:text-base leading-relaxed">{a.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* NUESTRO ALCANCE — Tres formas de sonar + cards */}
      <section className="relative bg-neutral-950 py-20 md:py-28 px-6 border-y border-white/5">
        <div className="max-w-7xl mx-auto">
          <p className="font-mono-caps text-xs tracking-[0.3em] uppercase text-[#ff8a3c] mb-4">— Nuestro alcance —</p>
          <h2 className="font-display font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-4xl">
            Tres <span className="text-gradient-music">formas</span> de sonar
          </h2>

          <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {COLUMNS.map(({ Icon, title, text }, i) => (
              <div
                key={i}
                className="relative rounded-2xl border border-white/10 bg-black p-6 md:p-8 hover:border-[#ff8a3c]/40 transition-colors overflow-hidden"
              >
                <div className="absolute -top-16 -right-16 w-44 h-44 rounded-full bg-[#ff6a2b]/15 blur-3xl pointer-events-none" />
                <div className="relative">
                  <span className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#ffa957] to-[#ff6a2b] flex items-center justify-center shadow-lg shadow-[#ff6a2b]/20 mb-6">
                    <Icon className="w-5 h-5 text-black" />
                  </span>
                  <h3 className="font-display font-bold text-2xl md:text-3xl text-white leading-tight">{title}</h3>
                  <p className="mt-4 text-white/70 text-base leading-relaxed">{text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PORTAFOLIO — Galería */}
      <section className="relative bg-black py-20 md:py-28 px-6 border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <p className="font-mono-caps text-xs tracking-[0.3em] uppercase text-white/40 mb-4">— Portafolio —</p>
          <h3 className="font-display font-black text-3xl sm:text-4xl md:text-5xl leading-[1.05] max-w-4xl">
            El <span className="text-gradient-music">ADN sonoro</span> de nuestros clientes
          </h3>
          <p className="mt-5 max-w-2xl text-white/60 text-base md:text-lg leading-relaxed">
            Casos reales agrupados por el tipo de intervención sonora que realizamos.
          </p>

          <div className="mt-14 md:mt-20">
            <VideoGallery groups={GALLERY_GROUPS} />
          </div>
        </div>
      </section>

      {/* SECCIÓN — Cómo construimos el ADN sonoro */}
      <section className="relative bg-neutral-950 py-20 md:py-28 px-6 border-y border-white/5">
        <div className="max-w-7xl mx-auto">
          <p className="font-mono-caps text-xs tracking-[0.3em] uppercase text-white/40 mb-4 md:mb-6">— El proceso —</p>
          <h2 className="font-display font-black text-4xl sm:text-5xl md:text-5xl lg:text-6xl leading-[1.05] max-w-5xl" style={{ wordBreak: "keep-all", overflowWrap: "normal" }}>
            Cómo construimos el <span className="text-gradient-music">ADN sonoro</span> de tu marca
          </h2>

          <div className="mt-12 md:mt-16 relative">
            <div className="hidden xl:block absolute top-14 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#ff6a2b]/40 to-transparent" />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5 relative z-10">
              {ADN_STEPS.map(({ n, Icon, title, desc }) => (
                <div key={n} className="rounded-2xl border border-white/10 bg-neutral-950 p-6 md:p-7 hover:border-[#ff8a3c]/40 transition-colors">
                  <div className="flex items-center justify-between mb-6">
                    <span className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#ffa957] to-[#ff6a2b] flex items-center justify-center shadow-lg shadow-[#ff6a2b]/20">
                      <Icon className="w-5 h-5 text-black" />
                    </span>
                    <span className="font-display font-black text-3xl text-white/10">{n}</span>
                  </div>
                  <h3 className="font-display font-bold text-base md:text-lg text-white leading-snug pt-1">{title}</h3>
                  <p className="mt-3 text-white/60 text-sm leading-relaxed">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative bg-black py-20 md:py-28 px-6">
        <div className="max-w-4xl mx-auto text-center rounded-3xl border border-[#ff6a2b]/30 bg-gradient-to-br from-[#ff6a2b]/12 via-black to-black p-8 md:p-16">
          <h2 className="font-display font-black text-[26px] sm:text-3xl md:text-4xl lg:text-5xl leading-tight text-white" style={{ wordBreak: "keep-all", overflowWrap: "normal" }}>
            ¿Y si sonar te hiciera <span className="text-gradient-music">inconfundible</span>?
          </h2>
          <p className="mt-6 text-white/70 text-base md:text-lg max-w-xl mx-auto">
            Diseñemos juntos el ADN sonoro que hará crecer tu marca.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            <Link to="/contact" className="btn-shine inline-flex items-center gap-3 rounded-full bg-white text-black pl-6 pr-5 py-3.5 font-mono-caps text-xs tracking-[0.2em] uppercase hover:bg-neutral-100 transition-colors">
              Quiero empezar a sonar
              <span className="w-7 h-7 rounded-full bg-[#ff6a2b] text-black flex items-center justify-center"><ArrowRight className="w-3.5 h-3.5" /></span>
            </Link>
          </div>
        </div>
      </section>

      <Footer footer={content.footer} />
      <WhatsAppButton />
    </div>
  );
}
